module.exports = __webpack_public_path__ + "static/media/azure.d36fd641.svg";